import { Selectors } from './rootSelectors';
import { MiddlewareManager } from './middleware';
import type { IAdditionalSelectors, IConfigSalesCheckin, IHostActions } from '@makemydeal/dr-sales-checkin-types';

export let selectors: Selectors;
export let middlewareManager: MiddlewareManager;
export let config: IConfigSalesCheckin;

export interface IInitResult {
    selectors: Selectors;
    middlewareManager: MiddlewareManager;
}

export const init = (
    appName: string,
    additionalSelectors: IAdditionalSelectors,
    hostActions: IHostActions,
    initConfig: IConfigSalesCheckin,
    root: string
): IInitResult => {
    selectors = new Selectors(appName, additionalSelectors);
    middlewareManager = new MiddlewareManager(selectors, hostActions, initConfig, root);
    config = initConfig;
    return {
        selectors,
        middlewareManager
    };
};
